import type { SealsQueryVariables, Seals_Bool_Exp } from "gql/api";
import { Order_By } from "gql/api";

export function restoreSeals(arr: Array<string>): Seals_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function deleteSeals(arr: Array<string>): Seals_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export const defaultSealVars: SealsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { configuration: Order_By.Asc }
  ],
  where: {
    hps_thrust_chamber: { _eq: false }
  }
};

export const adminSealVars: SealsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { configuration: Order_By.Asc }
  ],
  where: {
    hps_thrust_chamber: { _eq: false }
  }
};

export const kocSealVars: SealsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { configuration: Order_By.Asc }
  ],
  where: {
    _and: [
      {
        _or: [
          { include_koc_timestamp: { _is_null: false } },
          { only_koc_timestamp: { _is_null: false } }
        ]
      },
      { hps_thrust_chamber: { _eq: false } }
    ]
  }
};
export const ecopetrolSealVars: SealsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { configuration: Order_By.Asc }
  ],
  where: {
    _and: [
      {
        _or: [
          { include_ecopetrol_timestamp: { _is_null: false } },
          { only_ecopetrol_timestamp: { _is_null: false } }
        ]
      },
      { hps_thrust_chamber: { _eq: false } }
    ]
  }
};
